// @flow

import React from 'react';
import { connect } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import { Switch, Route, Redirect } from 'react-router-dom';
import { fetchThreads } from '../actions/threads';
import { Message } from 'semantic-ui-react';
import { Header } from '../components/shared';
import Threads from './Threads';
import Messages from './Messages';

type Props = {
  history: any,
  isFetching: boolean,
  isError: boolean,
  fetchThreads: () => void,
};

class App extends React.Component<Props> {
  componentDidMount() {
    this.props.fetchThreads();
  }

  render() {
    const { history } = this.props;

    return (
      <ConnectedRouter history={history}>
        <div id="messaging-container">
          <Header />
          <Switch>
            <Route exact path="/" render={() => <Redirect to="/threads" />} />
            <Route exact path="/threads" component={Threads} />
            <Route exact path="/threads/:id/messages" component={Messages} />
            <Route
              render={() => (
                <Message icon="help" header={`La page demandée n'existe pas`} />
              )}
            />
          </Switch>
        </div>
      </ConnectedRouter>
    );
  }
}

export default connect(null, {
  fetchThreads,
})(App);



// WEBPACK FOOTER //
// ./src/modules/messaging/pages/App.js